import { useState } from "react";

import Button from "@components/button/button";
import { ButtonSize } from "@components/button/button-constants";

import TypingText from "./typing-text";

const AskAIErrorMessage = ({ onClickRetry }: { onClickRetry: () => void }) => {
  const [showRetryCTA, setShowRetryCTA] = useState(false);

  const handleCompleted = () => {
    setShowRetryCTA(true);
  };

  const typingText = "An error occurred while sending your message.";

  return (
    <div className="text-red-600 flex items-center gap-2">
      <TypingText
        key={typingText}
        text={typingText}
        onCompleted={handleCompleted}
      />
      {showRetryCTA && (
        <Button
          size={ButtonSize.medium}
          text="Try again?"
          onClick={onClickRetry}
        />
      )}
    </div>
  );
};

export default AskAIErrorMessage;
